export default function resizeRem(structWidth) {
  const width = structWidth || 375;
  const docEl = document.documentElement;
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  window.recalc = () => {
    const { clientWidth } = docEl;
    if (!clientWidth) return;
    let r = 100 * (clientWidth / width);
    r = r > 200 ? 200 : r; // 控制 rem 最大值

    docEl.style.fontSize = `${r}px`;
  };

  window.addEventListener(resizeEvt, window.recalc, false);
  document.addEventListener('DOMContentLoaded', window.recalc, false);
  window.recalc();
}
